module.exports = __webpack_public_path__ + "static/media/user-menu-icon-white.2ae1658c.svg";